import React, { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
import ListObjects from "../components/listObjects"
import Subscription from "../components/subscription"
import PostsGroup from "../components/posts/posts-group"
import Post from "../components/posts/post"
import products from "../data/products"
import SEO from "../components/seo"

import * as postsGroupStyles from "../components/posts/postsGroup.module.scss"
import * as pageStyles from "../scss/productsPage.module.scss"
import PrivateRoute from "../components/app/privateRoute"
import { Router } from "@reach/router"
import isLoggedIn from "../services/auth"
import clearLocalStorage from "../services/clearLocalStorage"

const ProductsPage = ({ jumpTo }) => {

    const [videoWatchNext, setVideoWatchNext] = useState(null);
    const [loggedIn, setLoggedIn] = useState('');

    const graphResult = useStaticQuery(graphql`
    {
        wpKurs(slug: {eq: "detox-me"}) {
          id
          title
          renderContent
        }
      }
  `)


    const jumpToPageSection = () => {
        let element = document.getElementById(jumpTo)

        window.scrollTo({
            top: element.offsetTop - 150,
            left: 0,
            behavior: 'smooth'
        });

    }

    useEffect(() => {

        if (jumpTo) {
            jumpToPageSection();
        }

        isLoggedIn().then(loggedIn => {
            setLoggedIn(loggedIn);
            if (!loggedIn) {
                clearLocalStorage();
            }
        });


        if (!localStorage.getItem('videoProgress')) return;
        if (!localStorage.getItem('lessons')) return;

        let videoWatchNextSet = false;
        let videoprogressArray = localStorage.getItem('videoProgress');
        if (videoprogressArray == null) return null;
        videoprogressArray = JSON.parse(videoprogressArray);

        if(typeof videoprogressArray === 'string'){
            videoprogressArray = JSON.parse(videoprogressArray);
        }

        if (videoprogressArray === undefined) return null;

        let lessonsArray = JSON.parse(localStorage.getItem('lessons'));

        if (lessonsArray !== null && videoprogressArray !== null) {

            videoprogressArray.sort((a, b) => a - b)

            let indexLastWatchedVideo = videoprogressArray.find(element => element.watched === true);

            if (indexLastWatchedVideo <= videoprogressArray.length - 2) {

            }

            lessonsArray.sort((a, b) => {
                return parseFloat(b.point) > parseFloat(a.point);
            });

            if (videoprogressArray[videoprogressArray.length - 1].watched) {
                lessonsArray.sort((a, b) => {
                    return parseFloat(a.point) > parseFloat(b.point);
                });
            }

            lessonsArray.forEach((lesson, lessonKey) => {

                videoprogressArray.forEach(progress => {

                    if (parseFloat(progress.id) == parseFloat(lesson.point)) {

                        if (!videoWatchNextSet && progress.watched) {

                            videoWatchNextSet = true;
                            setVideoWatchNext(lessonsArray[lessonKey - 1])

                        }

                    }

                })

            })

        }

    }, [])

    const courseData = JSON.parse(graphResult.wpKurs.renderContent)

    const content = courseData.map((module, moduleKey) => {

        let elements = [];

        if (module.subheadline !== undefined) {
            elements.push(<h1 key="subheadline" style={{ marginTop: 30 }} className={postsGroupStyles.moduleHeadline}> {module.subheadline}</h1>);
        }
        elements.push(<h1 key="headline" id={module.headline} className={postsGroupStyles.moduleHeadline}> {module.headline}</h1>);


        if (module.lessons[0].id == "file") {

            let files = [];

            module.lessons.forEach((file, i) => {

                files.push({
                    id: 1,
                    title: file.title,
                    sourceUrl: file.url,
                    type: "document",
                });

            })

            elements.push(<div key={'div_'+moduleKey} className={pageStyles.marginTop}>
                <ListObjects
                    title="PDF Downloadbereich"
                    objects={files}
                    key={moduleKey}
                    loggedIn={loggedIn}
                    isOnlyPDF={true}
                />
            </div>)
        } else {
            let sameModule = true;
            let lastPoint = null;
            module.lessons.forEach((lesson, i) => {

                if (lesson["type"] == "big") {

                    let modulePoint = lesson.point.split(".")[0]

                    if (lastPoint === null) {
                        lastPoint = modulePoint;
                    }

                    if (lastPoint != modulePoint) {
                        sameModule = false;
                    }

                } else if (lesson["id"] == "lesson_container") {


                    lesson.lessons.forEach((smallLesson, i) => {

                        let modulePoint = parseInt(smallLesson.point.split(".")[0])


                        if (lastPoint === null) {
                            lastPoint = modulePoint;
                        }

                        if (lastPoint != modulePoint) {
                            sameModule = false;

                        }

                    })

                }

            })

            module.lessons.forEach((lesson, i) => {

                if (lesson["type"] == "big") {
                    elements.push(<Post
                        key={i}
                        type="large"
                        sourcePosition="leftlistObjects"
                        item={lesson}
                        watched
                        loggedIn={loggedIn}
                        showPoint={sameModule}
                    />)

                } else if (lesson["id"] == "lesson_container") {

                    let smallItems = [];

                    lesson.lessons.forEach((smallLesson, i) => {
                        smallItems.push(<Post key={i} showPoint={sameModule} loggedIn={loggedIn} type="small" item={smallLesson} />)
                    })

                    smallItems = <div key={'div_'+i} className={postsGroupStyles.threeItems}>{smallItems}</div>;

                    elements.push(smallItems);

                }

            })
        }
        return (<PostsGroup key={moduleKey} title={module.title}>{elements}</PostsGroup>)
    })

    return (
        <Layout>
            <SEO
                title="Kursübersicht "
                description="Dein 7-Tage Detox Kurs - Alles was du brauchst, um optimal zu entgiften! Mit über 45 Videoanleitungen in HD, 7 strukturierten Tagesplänen, einem Detox-Rezeptbuch und alle notwendigen Unterlagen für eine erfolgreiche Detox-Woche."
                keywords="Detox, Abnehmen, Fasten, Online, Kurs, Entgiften,Entschlacken"
                author="spectory"
            />
            <div className={`container ${pageStyles.container}`}>

                {
                    videoWatchNext !== null && loggedIn !== '' && <>
                        <h2>Als nächstes:</h2><br />
                        <Post type="large" active={true} loggedIn={loggedIn} item={videoWatchNext} />
                    </>
                }

                {

                    content
                }
            </div>
            <Subscription />
        </Layout>
    )
}

export default ProductsPage;
